import { useEffect, useState } from "react";
import { Package, FileText } from "lucide-react";
import { PageHeader } from "@trillion/ui/components/admin/page-header";
import { StatCard } from "@trillion/ui/components/admin/stat-card";
import { Card } from "@trillion/ui/components/ui/card";
import { Skeleton } from "@trillion/ui/components/ui/skeleton";
import { adminApi } from "@/lib/admin-api";

export function DashboardPage() {
  const [productCount, setProductCount] = useState<number | null>(null);
  const [articleCount, setArticleCount] = useState<number | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchStats() {
      try {
        const [productStats, articleStats] = await Promise.all([
          adminApi.products.stats(),
          adminApi.articles.stats(),
        ]);
        setProductCount(productStats.total);
        setArticleCount(articleStats.total);
      } catch {
        // Stats may fail if backend isn't running — show 0
        setProductCount(0);
        setArticleCount(0);
      } finally {
        setIsLoading(false);
      }
    }
    fetchStats();
  }, []);

  return (
    <div className="flex flex-col gap-6 p-6">
      <PageHeader
        title="Dashboard"
        description="Overview of your Help content"
      />

      {isLoading ? (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 2 }).map((_, i) => (
            <Card key={i} className="p-6">
              <Skeleton className="h-4 w-24 mb-2" />
              <Skeleton className="h-8 w-16 mb-1" />
              <Skeleton className="h-3 w-32" />
            </Card>
          ))}
        </div>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <StatCard
            title="Total Products"
            value={productCount ?? 0}
            description="Products in the catalog"
            icon={<Package className="size-4" />}
          />
          <StatCard
            title="Total Articles"
            value={articleCount ?? 0}
            description="Help articles published"
            icon={<FileText className="size-4" />}
          />
        </div>
      )}
    </div>
  );
}
